import { useAuth } from "../auth/useAuth";

export function DashboardPage() {
  const { user, claims, signOut } = useAuth();

  const onSignOut = () => {
    void signOut();
  };

  if (!user) {
    return <div role="status">Loading user…</div>;
  }

  return (
    <main style={{ padding: "2rem", maxWidth: 800, margin: "0 auto" }}>
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "2rem",
        }}
      >
        <h1>Dashboard</h1>
        <button type="button" onClick={onSignOut}>
          Sign Out
        </button>
      </header>

      <section
        aria-label="User profile"
        style={{
          padding: "1rem",
          border: "1px solid #e5e7eb",
          borderRadius: "0.5rem",
          marginBottom: "1.5rem",
        }}
      >
        <dl
          style={{
            display: "grid",
            gridTemplateColumns: "max-content 1fr",
            gap: "0.5rem 1rem",
            margin: 0,
          }}
        >
          <dt>
            <strong>Email:</strong>
          </dt>
          <dd data-testid="user-email" style={{ margin: 0 }}>
            {user.email}
          </dd>
          <dt>
            <strong>Company ID:</strong>
          </dt>
          <dd data-testid="user-company-id" style={{ margin: 0 }}>
            {user.companyId}
          </dd>
          <dt>
            <strong>Company:</strong>
          </dt>
          <dd style={{ margin: 0 }}>{user.companyName}</dd>
          <dt>
            <strong>Role:</strong>
          </dt>
          <dd data-testid="user-role" style={{ margin: 0 }}>
            {user.role}
          </dd>
        </dl>
      </section>

      {import.meta.env.DEV && claims && (
        <section
          aria-label="Raw JWT claims (dev only)"
          style={{
            padding: "1rem",
            border: "1px dashed #d1d5db",
            borderRadius: "0.5rem",
            background: "#f9fafb",
          }}
        >
          <h2 style={{ marginTop: 0, fontSize: "1rem" }}>
            Raw JWT claims (dev only)
          </h2>
          <pre
            data-testid="raw-claims"
            style={{
              overflowX: "auto",
              fontSize: "0.875rem",
              margin: 0,
            }}
          >
            {JSON.stringify(claims, null, 2)}
          </pre>
        </section>
      )}
    </main>
  );
}
